module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slider",
    class: {
      active: _vm.isActive
    },
    on: {
      "mousedown": _vm.sliderMove
    }
  }, [_c('div', {
    staticClass: "thumb-container",
    style: ({
      left: _vm.left + '%'
    }),
    on: {
      "touchstart": _vm.onMouseDown,
      "mousedown": _vm.onMouseDown
    }
  }, [_c('div', {
    staticClass: "thumb"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f063d11","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Slider.vue
// module id = 197
// module chunks = 1